import { FullTextSearchAutocomplete, KnownSearchAutocomplete } from "Models/Search";
import { useEffect, useState } from "react";
import { autocomplete } from "search.autocomplete";
import { VenueSearchAutocomplete, VenueGroupSearchAutocomplete, GeoSearchAutocomplete, IVenueSearchAutocomplete, IVenueGroupSearchAutocomplete, IGeoSearchAutocomplete } from "Services/API/API";

function useSearchAutocomplete() {
   const [isLoading, setIsLoading] = useState(false);
   const [query, setQuery] = useState<string | null | undefined>(null);
   const [options, setOptions] = useState<KnownSearchAutocomplete[]>([]);

   useEffect(() => {
      const abortController = new AbortController();

      if (query) {
         setIsLoading(true);
         autocomplete(query, items => {
            setOptions([new FullTextSearchAutocomplete(query), ...items.filter(x => !x.extended_line && !x.final_row && !x.currentLocation && !x.smart_search).map(x => {
               if (x.VenueId) {
                  const props: IVenueSearchAutocomplete = {
                     venueName: x.label!,
                     venueId: x.VenueId!,
                     isPreferred: x.IsPreferred! || false
                  };
                  return VenueSearchAutocomplete.fromJS(props);
               }
               else if (x.VenueGroupId) {
                  const props: IVenueGroupSearchAutocomplete = {
                     venueGroupName: x.label!,
                     venueGroupId: x.VenueGroupId!,
                     isPreferred: x.IsPreferred! || false,
                     venuesCount: x.LocationsCount!,
                     iconUrl: x.ImageUrl ?? undefined
                  };
                  return VenueGroupSearchAutocomplete.fromJS(props);
               }
               else /* if (x.label) */ {
                  const props: IGeoSearchAutocomplete = {
                     geoQuery: x.label!
                  };
                  return GeoSearchAutocomplete.fromJS(props);
               }
            })]);
            setIsLoading(false);
         });
      }
      else {
         setOptions([]);
      }

      return function cleanup() {
         abortController.abort();
      }
   }, [query]);

   return {
      isLoading: isLoading,
      options: options,
      handleSearch: setQuery
   }
}

export default useSearchAutocomplete;